import axios from "axios";
import config from "@/config";
import userConfig from "@/store/modules/userConfig";


const state = {
    orders: []
};

const getters = {
    getOrders(state) {
        return state.orders
    }
}

const mutations = {
    setOrder(state, data) {
        state.orders.push(data)
    },

    setOrders(state, data) {
        state.orders = data
    }
};

const actions = {

    sendOrdersStore(context, data) {
        axios.post(config.api + 'add-order', data)
            .then(response => {
                context.commit('setOrder', response.data)
                context.dispatch('cleanCartStore')
                context.dispatch('removeActiveClientStore')

            })
            .catch(error => {
                console.error(error);
            })

    },

    editOrdersStore(context, data) {
        axios.post(config.api + `edit-order/${data.order_id}`, data.query)
            .then(() => {
                data.onSave()
            })
            .catch(error => {
                console.error(error);
            })

    },

    fetchOrders(context, data) {

        axios.post(config.api + 'get-orders', {
            manager_id: data.id,
            currency: data.userConfig.currency,
        })
            .then(response => {
                context.commit('setOrders', response.data)
            })
            .catch(() => {
                context.commit('setOrders', {})
            })

    },

    fetchOrderDetails(context, data) {
        return axios.post(config.api + 'get-order-items-by-order', {
            order_id: data.id,
            currency: userConfig.currency,
        })

    },

    removeProductFromOrder(context, data) {
        return axios.post(config.api + `remove-order-item/${data.order_id}/${data.product_id}`, {
            count: data.count
        })
    },

    removeArrayProductFromOrder(context, data) {
        return axios.post(config.api + `remove-order-items/${data.order_id}`, {
            items: data.items
        })
    }
};

export default {
    state,
    getters,
    mutations,
    actions,
};
